// extracted by mini-css-extract-plugin
export default {"btn":"table_btn__V4lbF","deleteBtn":"table_deleteBtn__fsv39","editBtn":"table_editBtn__9CqYK"};